import jsonPath from 'jsonpath';
import {
  ChoiceItem,
  ChoiceType,
  JsonObject,
  ListChoiceItem,
  ManualChoiceItem,
  MappingChoice,
} from '../Choices';
import stringifyAny from './stringifyAny';

// is the same in front-end and back-end
// when refactoring with nx ; use the same helpers!
export function createValueForManualChoiceItem(
  choiceItem: ManualChoiceItem,
  jsonObject: JsonObject = {}
): string {
  if (!choiceItem.value) {
    return '';
  }
  let value: string;
  switch (choiceItem.type) {
    case 'prefix':
      return `${choiceItem.value}`;
    case 'mapping':
      value = createValueFromPath(jsonObject, choiceItem.value);
      // If the value is empty, return the jsonPath itself to make it visible
      return value.trim() ? value : choiceItem.value;
    default:
      return '';
  }
}
export function createFromManualChoice(
  preference?: ManualChoiceItem[],
  jsonObject?: JsonObject,
  onlyPrefix?: boolean
): string {
  return preference
    ? preference.reduce((prevValue: string, choiceItem: ManualChoiceItem) => {
        if (onlyPrefix) {
          return `${prevValue}${prevValue ? ', ' : ''}${createValueForManualChoiceItem(
            choiceItem,
            jsonObject
          )}`;
        }
        return `${prevValue}${createValueForManualChoiceItem(choiceItem, jsonObject)}`;
      }, '')
    : '';
}
export function getIdFromMapping(
  mappingChoice?: MappingChoice,
  preference?: Record<string, string>,
  jsonObject?: JsonObject
): string | undefined {
  if (!preference || !mappingChoice) {
    return;
  }

  const currentValue = jsonPath.query(jsonObject, mappingChoice.fromField);
  if (currentValue && currentValue.length > 0) {
    return preference[currentValue[0]];
  }
}

export function getLabelFromMapping(
  mappingChoice?: MappingChoice,
  preference?: Record<string, string>,
  jsonObject?: JsonObject
): string {
  const currentId = getIdFromMapping(mappingChoice, preference, jsonObject);

  const currentChoice = mappingChoice?.choices.to.find((toChoice) => toChoice.id === currentId);

  return currentChoice?.label || '';
}

export function getIdFromList(preference?: ListChoiceItem): string | undefined {
  if (!preference) {
    return;
  }

  return preference.id;
}

export function createFromList(preference?: ListChoiceItem): string {
  if (!preference) {
    return '';
  }

  return preference.label;
}

export function createValueFromPath(
  jsonObject: JsonObject,
  xpath: string,
  separator = ';'
): string {
  const result = jsonPath.query(jsonObject, xpath);
  switch (result.length) {
    case 1: {
      return `${stringifyAny(result[0], { dateFormat: 'dd-MM-yyyy' })}`;
    }
    default:
      return `${result.reduce(
        (prevRes: string, res: string, index: number) =>
          `${prevRes} ${index === 0 ? '' : separator} ${stringifyAny(res, {
            dateFormat: 'dd-MM-yyyy',
          })}`,
        ''
      )}`;
  }
}

export function getKeyFromPreference(type: ChoiceType, preference: ChoiceItem): string {
  switch (type) {
    case 'list':
      return (preference as ListChoiceItem)?.id;
    case 'boolean':
      return `${preference as boolean}`;
    /**
     * manual dependencies that have a choice return "true", in case they are empty it returns "false"
     */
    case 'manual': {
      if (!preference || (preference as ManualChoiceItem[])?.length === 0) {
        return 'false';
      } else {
        return 'true';
      }
    }
    default:
      throw new Error(`getKeyFromPreference for ${type} not yet supported`);
  }
}
